var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCloseAccordion(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_98_150)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M19.0695 3.92363C19.335 3.92394 19.5896 4.02966 19.7775 4.21754C19.9654 4.40543 20.0711 4.66009 20.0714 4.92553L20.0786 12.0039C20.0743 12.2663 19.9671 12.5164 19.7801 12.7001C19.5931 12.8839 19.3412 12.9868 19.0788 12.9865C18.8163 12.9862 18.5642 12.8829 18.3768 12.6987C18.1894 12.5145 18.0817 12.2643 18.0769 12.0018L18.0721 7.34004L5.63683 19.7753C5.44929 19.9629 5.19478 20.0681 4.92929 20.0678C4.6638 20.0675 4.40908 19.9618 4.22116 19.7739C4.03323 19.586 3.92751 19.3312 3.92724 19.0658C3.92697 18.8003 4.03217 18.5458 4.21971 18.3582L16.655 5.92292L11.9932 5.91816C11.7308 5.91334 11.4805 5.80563 11.2963 5.61823C11.1122 5.43084 11.0088 5.17876 11.0085 4.91628C11.0083 4.6538 11.1111 4.40193 11.2949 4.21492C11.4787 4.0279 11.7287 3.9207 11.9912 3.9164L19.0695 3.92363Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_98_150"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white",
    transform: "matrix(1 0 0 -1 0 24)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCloseAccordion);
export default __webpack_public_path__ + "static/media/closeAccordion.0d5172a87ddcbe6a1d16d7af68eaf750.svg";
export { ForwardRef as ReactComponent };